import React from 'react'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import ReactDOM from 'react-dom'
import { LoadStyles } from '@drifthq/tide-core'
import { createEpicMiddleware } from 'redux-observable'
import thunk from 'redux-thunk'
import { routerMiddleware as createRouterMiddleware } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'

import App from 'layouts/App'
import { initializeSentry } from 'utils/logger'
import { rootReducer, rootEpic } from 'modules'

const history = createHistory({ basename: '/letsgo' })

const epicMiddleware = createEpicMiddleware(rootEpic)
const routerMiddleware = createRouterMiddleware(history)
export const store = createStore(rootReducer, applyMiddleware(routerMiddleware, epicMiddleware, thunk))
window.store = store

initializeSentry()
LoadStyles()

ReactDOM.render(
  <Provider store={store}>
    <App history={history}/>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js